"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreUserInvitationStatus = exports.CoreUserRole = void 0;
var CoreUserRole;
(function (CoreUserRole) {
    CoreUserRole["OWNER"] = "owner";
    CoreUserRole["ADMIN"] = "admin";
    CoreUserRole["READONLY"] = "readonly";
    CoreUserRole["SERVICE"] = "service";
})(CoreUserRole = exports.CoreUserRole || (exports.CoreUserRole = {}));
var CoreUserInvitationStatus;
(function (CoreUserInvitationStatus) {
    CoreUserInvitationStatus["ACCEPTED"] = "accepted";
    CoreUserInvitationStatus["PENDING"] = "pending";
    CoreUserInvitationStatus["UNSENT"] = "unsent";
})(CoreUserInvitationStatus = exports.CoreUserInvitationStatus || (exports.CoreUserInvitationStatus = {}));
//# sourceMappingURL=users.js.map